import React, { FC } from 'react';

import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import Edit from '@mui/icons-material/Edit';

import InformationField from '../../../sharedModules/form/components/InformationField';

import { BackflowJobItem } from '../../model';

interface BackflowDeviceDisplayProps {
  backflowJobItem: BackflowJobItem;
  onEdit: () => void;
}

const BackflowDeviceDisplay: FC<BackflowDeviceDisplayProps> = ({ backflowJobItem, onEdit }) => {
  return (
    <Card>
      <CardContent>
        <Grid container>
          <Grid item xs={12}>
            <Typography variant="h5" component="h2" gutterBottom>
              Backflow Device
            </Typography>
          </Grid>
          <Grid item xs={12} md={6} style={{ marginTop: 15 }}>
            <InformationField label="Asset No" value={backflowJobItem?.asset_no} />
          </Grid>
          <Grid item xs={12} md={6} style={{ marginTop: 15 }}>
            <InformationField label="Equipment Type" value={backflowJobItem?.equipment_type_label} />
          </Grid>
          <Grid item xs={12} md={6} style={{ marginTop: 15 }}>
            <InformationField label="Backflow Preventer Make" value={backflowJobItem?.bfp_manufacturer_name} />
          </Grid>
          <Grid item xs={12} md={6} style={{ marginTop: 15 }}>
            <InformationField label="Model" value={backflowJobItem?.model_no} />
          </Grid>
          <Grid item xs={12} md={6} style={{ marginTop: 15 }}>
            <InformationField label="Serial" value={backflowJobItem?.serial_no} />
          </Grid>
          <Grid item xs={12} md={6} style={{ marginTop: 15 }}>
            <InformationField label="Water Meter Make" value={backflowJobItem?.wm_manufacturer_name} />
          </Grid>
          <Grid item xs={12} md={6} style={{ marginTop: 15 }}>
            <InformationField
              label="Water Meter Brass Body Serial"
              value={backflowJobItem?.water_meter_serial || 'Missing'}
            />
          </Grid>
          <Grid item xs={12} md={6} style={{ marginTop: 15 }}>
            <InformationField
              label="Water Meter Head Serial"
              value={backflowJobItem?.water_meter_serial_secondary || 'Missing'}
            />
          </Grid>
          <Grid item xs={12} md={6} style={{ marginTop: 15 }}>
            <InformationField label="Location" value={backflowJobItem?.location || 'Missing'} />
          </Grid>
          <Grid item xs={12} style={{ marginTop: 15, display: 'flex', alignItems: 'center' }}>
            <Button variant="contained" onClick={onEdit} style={{ marginRight: 15 }}>
              Edit Details &nbsp;
              <Edit />
            </Button>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default BackflowDeviceDisplay;
